import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnInit, Optional, Inject, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare const $: any;
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { datePickerMinDate, noWhitespaceInRequiredValidator } from '../../shared/constants';
import { noop } from 'jquery';
import { NavbarComponent } from '../../navbar/navbar.component';
import Swal from 'sweetalert2';
import { NgxFileDropEntry, FileSystemFileEntry } from 'ngx-file-drop';
import { environment } from '../../../environments/environment';

@Component({
	selector: 'app-task-form',
	templateUrl: './task-form.component.html',
	styleUrl: './task-form.component.scss'
})
export class TaskFormComponent {
	File_Storage_URL = environment.File_Storage_URL;
	moduleForm: FormGroup = this.formBuilder.group({
		department_id: [null, [Validators.required]],
		lead_id: [null, [Validators.required]],
		assigned_id: [null, [Validators.required]],
		status_id: [1, [Validators.required]],
		due_date: [null, [Validators.required]],
		start_date: [null],
		fin_date: [null],
		sub_task: [null, [Validators.required]],
		is_finished: [false],
		notes: [null],
	});
	commentForm: FormGroup = this.formBuilder.group({
		comment: [null, [Validators.required]],
		attachment: [null],
		id: [null]
	});
	showLoader = false;
	showCommentLoader = false;
	pageLoading1 = false;
	pageLoading2 = false;
	showSubmitBtn = true;
	@Input() uId: any = null;
	@Input() statusList: any[] = [];
	@Input() userList: any[] = [];
	@Output() created = new EventEmitter<any>();
	@Output() cleared = new EventEmitter<any>();
	customError: any = {};
	formSubmitted = false;
	commentFormSubmitted = false;
	details: any = null;
	comments: any[] = [];
	minDate = datePickerMinDate;
	modalId = "createTaskModal" + this.getRandom5DigitNumber();
	getRandom5DigitNumber() {
		return Math.floor(Math.random() * 90000) + 10000;
	}

	constructor(private toastr: ToastrService, private apiService: ApiService, private formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }

	bindDepartment() {
		this.apiService.departmentList$.subscribe((departments: any[]) => {
			if (departments && departments.length) {
				if (departments.length === 1) {
					//If departments has only 1 entry then other are removed as user is Lead(with department) or Assignee
					this.f.department_id.setValue(departments[0].id);
					this.f.department_id.disable();
				} else {
					this.f.department_id.setValue(null);
					this.f.department_id.enable();
				}
			}
		});
	}

	initForm(uId: any) {
		this.uId = uId;
		this.showSubmitBtn = true;
		this.f.department_id.enable();
		this.f.lead_id.enable();
		this.f.assigned_id.enable();
		this.f.due_date.enable();
		this.f.sub_task.enable();
		this.f.is_finished.enable();
		this.f.notes.enable();
		this.f.status_id.enable();
		this.f.start_date.enable();
		this.f.fin_date.enable();
		if (this.uId) {
			this.getDetails();
			this.getComments();
		} else {
			this.moduleForm.reset();
			this.commentForm.reset();
			this.f.status_id.setValue(1);
			this.f.is_finished.setValue(false);
			this.formSubmitted = false;
			this.commentFormSubmitted = false;
			this.uId = null;
			this.bindDepartment();
		}
		this.openTaskModal();
	}

	get f() { return this.moduleForm.controls; }

	get fc() { return this.commentForm.controls; }

	clearForm() {
		this.uId = null;
		this.moduleForm.reset();
		this.commentForm.reset();
		this.f.status_id.setValue(1);
		this.formSubmitted = false;
		this.commentFormSubmitted = false;
		this.cleared.emit();
		$("#" + this.modalId).modal("hide");
		this.bindDepartment();
	}

	openTaskModal() {
		$("#" + this.modalId).modal("show");
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getTask({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.details = data;
				this.f.department_id.setValue(this.details.department);
				if (this.details.lead) {
					this.navbar.getValueFromUserList(this.details.lead, "id").then((val) => {
						this.f.lead_id.setValue(val);
					});
				}
				if (this.details.assigned) {
					this.navbar.getValueFromUserList(this.details.assigned, "id").then((val) => {
						this.f.assigned_id.setValue(val);
					});
				}
				this.f.status_id.setValue(this.details.status);
				this.f.due_date.setValue(this.apiService.getDateFromDateString(this.details.due_date, 'DD-MM-YYYY'));
				this.f.start_date.setValue(this.apiService.getDateFromDateString(this.details.start_date, 'DD-MM-YYYY'));
				this.f.fin_date.setValue(this.apiService.getDateFromDateString(this.details.fin_date, 'DD-MM-YYYY'));
				this.f.sub_task.setValue(this.details.sub_task);
				this.f.is_finished.setValue(this.details.is_finished);
				this.f.notes.setValue(this.details.notes);
				let showSubmitBtn1 = true;
				let showSubmitBtn2 = true;
				let showSubmitBtn3 = true;
				if (!this.navbar.user?.tms_access?.edit_task) {
					this.f.department_id.disable();
					this.f.lead_id.disable();
					this.f.assigned_id.disable();
					this.f.due_date.disable();
					this.f.sub_task.disable();
					this.f.notes.disable();
					showSubmitBtn1 = false;
				}
				if (!this.navbar.user?.tms_access?.change_task_status && this.navbar.user?.id != this.details.lead && this.navbar.user?.id != this.details.assigned) {
					this.f.status_id.disable();
					this.f.start_date.disable();
					this.f.fin_date.disable();
					showSubmitBtn2 = false;
				}
				if (!this.navbar.user?.tms_access?.finish_task) {
					this.f.is_finished.disable();
					showSubmitBtn3 = false;
				}
				this.showSubmitBtn = showSubmitBtn1 || showSubmitBtn2 || showSubmitBtn3;
			}, error: (error) => {
				this.pageLoading1 = false;
				if (error.status == 401) { return }
				this.toastr.error("Something went wrong", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			}
		});
	}

	getComments() {
		this.pageLoading2 = true;
		this.apiService.getTaskComments({ id: this.uId }).subscribe({
			next: (data: any) => {
				this.pageLoading2 = false;
				this.comments = data;
			}, error: (error) => {
				this.pageLoading2 = false;
				this.comments = [];
				if (error.status == 401) { return }
			}
		});
	}

	clearCustomError() {
		Object.keys(this.f).forEach(key => {
			if (this.f[key].hasError('incorrect')) {
				try {
					delete this.f[key].errors?.incorrect;
					this.f[key].updateValueAndValidity();
				} catch (error) {
					noop;
				}
			}
		});
		this.customError = {};
	}

	saveData() {
		this.formSubmitted = true;
		this.clearCustomError();
		if (this.moduleForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			department_id: this.f.department_id.value,
			lead_id: this.f.lead_id.value,
			assigned_id: this.f.assigned_id.value,
			status_id: this.f.status_id.value,
			due_date: this.apiService.getDateStringFromDate(this.f.due_date.value, 'YYYY-MM-DD'),
			start_date: this.apiService.getDateStringFromDate(this.f.start_date.value, 'YYYY-MM-DD'),
			fin_date: this.apiService.getDateStringFromDate(this.f.fin_date.value, 'YYYY-MM-DD'),
			sub_task: this.f.sub_task.value,
			is_finished: this.f.is_finished.value || false,
			notes: this.f.notes.value,
		};
		if (this.uId) {
			data.id = this.uId;
		}
		this.showLoader = true;
		this.apiService.createUpdateTask(data).subscribe({
			next: (data: any) => {
				this.showLoader = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.created.emit(data);
				this.clearForm();
			}, error: (error) => {
				this.showLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showError(field: string) {
		if (this.f[field].invalid && (this.formSubmitted || this.f[field].touched || this.f[field].dirty)) {
			return true;
		}
		return false;
	}

	saveComment() {
		this.commentFormSubmitted = true;
		if (this.commentForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			task_id: this.details.id,
			comment: this.fc.comment.value,
			attachment: this.fc.attachment.value,
		};
		if (this.fc.id.value) {
			data.id = this.fc.id.value;
		}
		this.showCommentLoader = true;
		this.apiService.createUpdateTaskComment(data).subscribe({
			next: (data: any) => {
				this.showCommentLoader = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.commentForm.reset();
				this.commentFormSubmitted = false;
				this.getComments();
			}, error: (error) => {
				this.showCommentLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	showErrorComment(field: string) {
		if (this.fc[field].invalid && (this.commentFormSubmitted || this.fc[field].touched || this.fc[field].dirty)) {
			return true;
		}
		return false;
	}

	bindEdit(commentObj: any, isEdit: boolean) {
		for (let i = 0; i < this.comments.length; i++) {
			this.comments[i].isEdit = false;
		}
		commentObj.isEdit = isEdit;
		/* this.fc.comment.setValue(commentObj.comment);
		this.fc.id.setValue(commentObj.enc_id); */
	}

	updateComment(commentObj: any) {
		if (!commentObj.comment) {
			this.toastr.info("Please enter comment", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		const data: any = {
			task_id: this.details.id,
			comment: commentObj.comment,
			attachment: commentObj.attachment,
			id: commentObj.enc_id
		};
		commentObj.showCommentLoader = true;
		this.apiService.createUpdateTaskComment(data).subscribe({
			next: (data: any) => {
				commentObj.showCommentLoader = false;
				this.toastr.success("Saved successfully", 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				commentObj.isEdit = false;
				this.getComments();
			}, error: (error) => {
				commentObj.showCommentLoader = false;
				if (error.status == 401) { return }
				let errorMsg = "Something went wrong.";
				this.toastr.error(errorMsg, 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	deleteComment(commentObj: any) {
		Swal.fire({
			title: 'Please confirm',
			html: 'Are you sure you want to delete comment?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Delete',
			confirmButtonColor: '#DC3545',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				this.apiService.deleteTaskComment(commentObj.enc_id).subscribe({
					next: (data: any) => {
						this.toastr.success("Comment deleted successfully", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.getComments();
					}, error: (error) => {
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	getLoggedInUserInitials() {
		return this.getInitials(this.navbar.user?.first_name + ' ' + this.navbar.user?.last_name);
	}

	getInitials(text: string) {
		try {
			return text.trim().split(" ").map((word: string) => {
				return word[0] ? word[0].toUpperCase() : "";
			}).join("");
		} catch (error) {
			return text;
		}
	}

	fileUploaderLoader = false;
	public fileUpload(files: NgxFileDropEntry[]) {
		for (const droppedFile of files) {
			if (droppedFile.fileEntry.isFile) {
				const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
				fileEntry.file((file: File) => {
					this.fileUploaderLoader = true;
					const formData = new FormData();
					formData.append("file", file);
					this.apiService.commentFileUpload(formData).subscribe({
						next: (data: any) => {
							this.fc.attachment.setValue(data);
							this.fileUploaderLoader = false;
						}, error: (error) => {
							this.fileUploaderLoader = false;
							this.toastr.error("Something went wrong.", 'Error', {
								tapToDismiss: true,
								closeButton: true,
								timeOut: 3000
							});
						}
					});
				});
			} else {
				this.toastr.error("Invalid File Format.", 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		}
	}

	deleteCommentFile(commentObj: any) {
		Swal.fire({
			title: 'Please confirm',
			html: 'Are you sure you want to delete file?',
			icon: 'question',
			showCancelButton: true,
			confirmButtonText: 'Delete',
			confirmButtonColor: '#DC3545',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				this.apiService.deleteCommentFile(commentObj.attachment).subscribe({
					next: () => {
						commentObj.attachment = null;
						const payload: any = {
							task_id: this.details.id,
							comment: commentObj.comment,
							attachment: commentObj.attachment,
							id: commentObj.enc_id
						};
						this.apiService.createUpdateTaskComment(payload).subscribe({
							next: () => {
								this.toastr.success("File deleted successfully", 'Success', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
								this.getComments();
							}, error: (error) => {
								this.toastr.error("Something went wrong", 'Error', {
									timeOut: 3000,
									tapToDismiss: true,
									closeButton: true
								});
							}
						});
					}, error: (error) => {
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}

	getFileName(filepath: string) {
		try {
			return filepath.split("/").pop() || "";
		} catch (error) {
			return filepath;
		}
	}
}
